import { Dot } from '@/features/map/types/shape'
import React from 'react'
import { Circle, Layer, Stage, Text } from 'react-konva'

type Props = {
  gatewayDot: Dot
  deviceDots?: Dot[]

  width?: number
  height?: number
}

function getDevicePosition(index: number, total: number, rssi: number | undefined, centerX: number, centerY: number) {
  const angle = (index / Math.max(total, 1)) * Math.PI * 2

  // stronger RSSI => closer to center
  const signalStrength = Math.min(Math.max(Math.abs(rssi ?? -80), 40), 90)

  const radius = ((signalStrength - 40) / 50) * 120 + 40

  return {
    x: centerX + Math.cos(angle) * radius,
    y: centerY + Math.sin(angle) * radius,
  }
}

export function GatewayCalibrationPreview({ gatewayDot, deviceDots = [], width = 600, height = 400 }: Props) {
  const centerX = width / 2
  const centerY = height / 2

  return (
    <div className="overflow-auto rounded-md border bg-muted/10">
      <Stage width={width} height={height}>
        <Layer>
          {/* Gateway */}
          <Circle x={centerX} y={centerY} radius={8} fill="#2563eb" stroke="white" strokeWidth={2} />

          <Text
            text={gatewayDot.label}
            x={centerX - 60}
            y={centerY + 20}
            width={120}
            align="center"
            fontSize={12}
            fontStyle="bold"
          />

          {/* Devices */}
          {deviceDots.map((device, index) => {
            const { x, y } = getDevicePosition(index, deviceDots.length, device.rssi, centerX, centerY)

            return (
              <React.Fragment key={device.id}>
                {/* line to gateway */}
                <Circle x={x} y={y} radius={6} fill="#22c55e" stroke="white" strokeWidth={2} />

                <Text text={device.label} x={x + 8} y={y - 8} fontSize={11} fill="#111827" />

                <Text text={`RSSI ${device.rssi ?? '-'}`} x={x + 8} y={y + 6} fontSize={10} fill="#6b7280" />
              </React.Fragment>
            )
          })}
        </Layer>
      </Stage>
    </div>
  )
}
